import type { ChangelogEntry, PaymentMethod } from "./types";

/**
 * Statische redactionele data. Geen backend: deze lijsten zijn de bron van
 * waarheid voor de publieke site. Alleen records met publication_status
 * "published" staan hier; concepten en ongeverifieerde aanbieders horen hier
 * niet thuis.
 */

export const PAYMENT_METHODS: PaymentMethod[] = [
  {
    id: "pm-ideal",
    name: "iDEAL",
    slug: "ideal",
    category: "bank",
    short_description: "De Nederlandse bankstandaard voor directe online betalingen.",
    intro:
      "Wat zijn de beste online casino's met iDEAL? Hieronder vind je onze casinoselectie, gevolgd door betaaltestgegevens en uitleg over stortingssnelheid, kosten en limieten. Je leest ook hoe je met je bankapp stort en via welke route je winst op je rekening terugkomt.",
    full_description:
      "iDEAL koppelt de betaalpagina van het casino aan je eigen bank. Je kiest je bank, bevestigt met de bankapp en het bedrag wordt direct van je betaalrekening afgeschreven. Omdat er geen tussenpartij tussen zit die geld voor je bewaart, is iDEAL vooral een stortmethode: uitbetalen gebeurt bij de meeste aanbieders via een gewone bankoverschrijving naar dezelfde rekening.",
    logo_url: null,
    deposit_supported: true,
    withdrawal_supported: false,
    typical_deposit_speed: "Direct",
    typical_withdrawal_speed: "1-3 werkdagen via bankoverschrijving",
    min_deposit_general: 1,
    max_deposit_general: 10000,
    typical_fees: "Meestal geen kosten voor de speler",
    mobile_support: true,
    verification_notes: "Rekening moet op naam van de speler staan; naamcontrole is standaard.",
    available_in_netherlands: true,
    publication_status: "published",
    seo_title: "Online Casino iDEAL 2026: Direct Storten via je Eigen Bankapp",
    meta_description:
      "Vind de beste online casino iDEAL keuze van november 2026. Getest op snelheid, kosten, limieten en uitbetaling. Ook: online casino iDEAL buitenland. 18+.",
    pros: [
      "Direct bijgeschreven",
      "Geen extra account nodig",
      "Bevestiging via je eigen bankapp",
      "Doorgaans geen kosten voor de speler",
    ],
    cons: [
      "Uitbetalen loopt meestal via bankoverschrijving",
      "Alleen beschikbaar met een Nederlandse bankrekening",
      "Geen chargeback-regeling zoals bij creditcards",
    ],
    faq_items: [
      {
        q: "Kun je met iDEAL ook laten uitbetalen?",
        a: "Bij de meeste aanbieders niet rechtstreeks. De uitbetaling gaat als bankoverschrijving terug naar dezelfde rekening waarmee je stortte.",
      },
      {
        q: "Zijn er kosten aan iDEAL?",
        a: "Voor de speler rekenen aanbieders doorgaans geen kosten. Controleer altijd de kassa van de aanbieder zelf.",
      },
      {
        q: "Hoe snel staat een iDEAL-storting op je account?",
        a: "Vrijwel altijd direct na bevestiging in je bankapp.",
      },
    ],
    sort_order: 1,
    last_verified_at: "2026-11-04T00:00:00Z",
  },
  {
    id: "pm-sofort",
    name: "Sofort",
    slug: "sofort",
    category: "bank",
    short_description: "Directe bankbetaling zonder aparte wallet, bekend uit Duitsland.",
    intro:
      "Op zoek naar de beste online casino's met Sofort? Op deze pagina vergelijk je onze casinoselectie op bankbetalingen, met betaaltestgegevens, stortlimieten en kosten. We leggen uit welke banken ondersteuning bieden, hoe je stort en waarom je uitbetaling meestal via een bankoverschrijving loopt.",
    full_description:
      "Sofort (onderdeel van Klarna) initieert een overschrijving vanaf je bankrekening. Het casino krijgt direct een betaalbevestiging, terwijl het geld via het normale betaalverkeer volgt. Uitbetalen via Sofort is ongebruikelijk; opnames lopen doorgaans via bankoverschrijving.",
    logo_url: null,
    deposit_supported: true,
    withdrawal_supported: false,
    typical_deposit_speed: "Direct",
    typical_withdrawal_speed: "1-3 werkdagen via bankoverschrijving",
    min_deposit_general: 5,
    max_deposit_general: 5000,
    typical_fees: "Meestal geen kosten voor de speler",
    mobile_support: true,
    verification_notes: "Je logt in via de omgeving van Sofort; niet elke Nederlandse bank ondersteunt dit.",
    available_in_netherlands: true,
    publication_status: "published",
    seo_title: "Sofort Casino 2026: Zo Werkt Klarna Sofort Bij Nederlandse Sites",
    meta_description:
      "Vind de beste Sofort casino's van november 2026. Bekijk onze tests van snelheid, stortlimieten, kosten en de uitbetaling via je bank. 18+.",
    pros: [
      "Directe bevestiging van de betaling",
      "Geen aparte wallet nodig",
      "Werkt met meerdere Europese banken",
    ],
    cons: [
      "Niet elke Nederlandse bank wordt ondersteund",
      "Opnemen is vrijwel nooit mogelijk",
      "Minder bekend bij Nederlandse spelers dan iDEAL",
    ],
    faq_items: [
      {
        q: "Is Sofort hetzelfde als Klarna?",
        a: "Sofort is onderdeel van Klarna, maar het is een aparte betaalmethode: je betaalt direct vanaf je bankrekening in plaats van achteraf.",
      },
      {
        q: "Kan ik met Sofort geld opnemen?",
        a: "Vrijwel nooit. Reken op een bankoverschrijving voor de uitbetaling.",
      },
    ],
    sort_order: 2,
    last_verified_at: "2026-11-03T00:00:00Z",
  },
  {
    id: "pm-apple-pay",
    name: "Apple Pay",
    slug: "apple-pay",
    category: "wallet",
    short_description: "Betalen met Face ID of Touch ID vanaf een Apple-apparaat.",
    intro:
      "Welke online casino's zijn het beste voor betalen met Apple Pay? Hieronder bekijk je onze casinoselectie en de betaaltestgegevens voor mobiele stortingen, kosten en limieten. Je leest hoe je met Face ID of Touch ID betaalt, wat een echte Apple Pay-knop onderscheidt van een kaartbetaling en hoe je winst laat uitbetalen.",
    full_description:
      "Bij Apple Pay bevestig je de betaling met Face ID, Touch ID of je toegangscode. De kaartgegevens worden niet gedeeld met de aanbieder. Belangrijk: betalen met een bankpas die toevallig in je Apple Wallet zit, is niet hetzelfde als een casino dat Apple Pay als eigen betaaloptie in de kassa aanbiedt. Wij markeren alleen dat laatste als ondersteuning.",
    logo_url: null,
    deposit_supported: true,
    withdrawal_supported: false,
    typical_deposit_speed: "Direct",
    typical_withdrawal_speed: "Uitbetaling via een andere methode",
    min_deposit_general: 10,
    max_deposit_general: 5000,
    typical_fees: "Geen kosten vanuit Apple; aanbieder kan afwijken",
    mobile_support: true,
    verification_notes: "Werkt alleen op ondersteunde Apple-apparaten met een gekoppelde kaart.",
    available_in_netherlands: true,
    publication_status: "published",
    seo_title: "Beste Apple Pay Casino's 2026: Online Casino met Apple Pay",
    meta_description:
      "Beste Apple Pay casino's van Nederland vergeleken: storten met Face ID in enkele seconden, limieten, kosten en uitbetaling per aanbieder getest. 18+.",
    pros: [
      "Betalen zonder kaartgegevens in te voeren",
      "Bevestiging met Face ID of Touch ID",
      "Zeer snel op mobiel",
    ],
    cons: [
      "Alleen op Apple-apparaten",
      "Uitbetalen gaat via een andere methode",
      "Nog beperkt aangeboden in de Nederlandse markt",
    ],
    faq_items: [
      {
        q: "Telt betalen met een kaart uit mijn Apple Wallet als Apple Pay?",
        a: "Nee. Wij tellen alleen aanbieders mee die Apple Pay als eigen optie in de kassa tonen.",
      },
      {
        q: "Kan ik met Apple Pay laten uitbetalen?",
        a: "Nee, kies bij de uitbetaling een methode die opnames ondersteunt, zoals een bankoverschrijving.",
      },
      {
        q: "Welke casino's accepteren Apple Pay?",
        a: "In Nederland zijn dat er nog maar weinig. Wij tellen alleen aanbieders mee die Apple Pay als eigen knop in de kassa tonen; een kaart die toevallig in je Apple Wallet zit, is iets anders.",
      },
      {
        q: "Bestaat er een speciale Apple Pay casino bonus?",
        a: "Nee. Je krijgt de gewone welkomstbonus van het casino, mits wallet- en kaartbetalingen niet zijn uitgesloten in de bonusvoorwaarden.",
      },
    ],
    sort_order: 3,
    last_verified_at: "2026-11-04T00:00:00Z",
  },
  {
    id: "pm-google-pay",
    name: "Google Pay",
    slug: "google-pay",
    category: "wallet",
    short_description: "Snel betalen vanaf Android met een gekoppelde kaart.",
    intro:
      "Hier vind je onze selectie van de beste online casino's voor Google Pay, met betaaltestgegevens en uitleg over mobiele stortingen, kosten en limieten. We laten zien waar je op let bij een Google Pay-knop in de kassa, hoe je betaling wordt bevestigd en welke route je voor uitbetalen nodig hebt. Google Play-tegoed is een andere dienst.",
    full_description:
      "Google Pay stuurt een versleuteld token in plaats van je kaartnummer naar de betaalverwerker. Voor de speler is het vooral een snellere kassa op mobiel. Opnames worden praktisch nooit via Google Pay verwerkt.",
    logo_url: null,
    deposit_supported: true,
    withdrawal_supported: false,
    typical_deposit_speed: "Direct",
    typical_withdrawal_speed: "Uitbetaling via een andere methode",
    min_deposit_general: 10,
    max_deposit_general: 5000,
    typical_fees: "Geen kosten vanuit Google; aanbieder kan afwijken",
    mobile_support: true,
    verification_notes: "Vereist een Google-account met een geverifieerde kaart.",
    available_in_netherlands: true,
    publication_status: "published",
    seo_title: "Beste Google Pay Casino's 2026: Online Casino met Google Pay",
    meta_description:
      "Vind de beste Google Pay casino's van november 2026. Getest op mobiele snelheid, stortlimieten, kosten en beschikbare uitbetaalroutes. 18+.",
    pros: [
      "Snelle kassa op Android",
      "Geen kaartgegevens invullen",
      "Kaartgegevens worden getokeniseerd",
    ],
    cons: [
      "Uitbetalen niet mogelijk",
      "Afhankelijk van je kaartuitgever",
      "Beperkt beschikbaar in Nederland",
    ],
    faq_items: [
      {
        q: "Heb ik een Android-toestel nodig?",
        a: "Google Pay werkt het beste op Android, maar is in sommige browsers ook op andere apparaten beschikbaar.",
      },
      {
        q: "Kan ik met Google Pay opnemen?",
        a: "Nee. Kies een uitbetaalmethode die opnames ondersteunt.",
      },
    ],
    sort_order: 4,
    last_verified_at: "2026-11-04T00:00:00Z",
  },
  {
    id: "pm-neteller",
    name: "Neteller",
    slug: "neteller",
    category: "wallet",
    short_description: "E-wallet die zowel storten als opnemen ondersteunt.",
    intro:
      "Welke online casino's passen het beste bij Neteller? Hieronder vergelijk je onze casinoselectie, met betaaltestgegevens over stortingen en opnames naar je wallet. Verder lees je welke limieten en kosten meetellen, wat verificatie vraagt en hoe je ontvangen winst doorboekt naar je bankrekening.",
    full_description:
      "Je laadt je Neteller-wallet op via bank of kaart en betaalt daarna in één stap bij de aanbieder. Omdat de wallet ook geld kan ontvangen, is Neteller een van de weinige methoden waarmee een uitbetaling vaak dezelfde dag zichtbaar is. Let op de wisselkoers- en opnamekosten van Neteller zelf.",
    logo_url: null,
    deposit_supported: true,
    withdrawal_supported: true,
    typical_deposit_speed: "Direct",
    typical_withdrawal_speed: "Vaak binnen 24 uur",
    min_deposit_general: 10,
    max_deposit_general: 10000,
    typical_fees: "Wallet kan kosten rekenen bij opname of valutawissel",
    mobile_support: true,
    verification_notes: "Wallet moet op dezelfde naam staan als het spelersaccount.",
    available_in_netherlands: true,
    publication_status: "published",
    seo_title: "Neteller Casino 2026: E-wallet die Ook Uitbetaalt — Onze Review",
    meta_description:
      "Vind de beste Neteller casino's van november 2026. Onze tests tonen kosten, limieten en welke aanbieders het snelst naar je wallet uitbetalen. 18+.",
    pros: [
      "Geschikt voor storten en opnemen",
      "Uitbetaling vaak binnen een dag",
      "Eén wallet voor meerdere aanbieders",
    ],
    cons: [
      "Neteller kan eigen kosten rekenen",
      "Soms uitgesloten van bonussen",
      "Extra verificatiestap bij de wallet",
    ],
    faq_items: [
      {
        q: "Kan ik met Neteller uitbetalen?",
        a: "Ja, bij aanbieders die Neteller ook als opnamemethode aanbieden. Controleer dit per aanbieder in de vergelijkingstabel.",
      },
      {
        q: "Zijn er kosten?",
        a: "De aanbieder rekent meestal niets, maar Neteller kan kosten rekenen voor opnemen of valutawissel.",
      },
    ],
    sort_order: 5,
    last_verified_at: "2026-11-03T00:00:00Z",
  },
  {
    id: "pm-hipay",
    name: "HiPay",
    slug: "hipay",
    category: "processor",
    short_description: "Betaaldienstverlener die meerdere methoden achter één kassa bundelt.",
    intro:
      "Zoek je de beste online casino's met betalingen via HiPay? Deze pagina brengt onze casinoselectie, betaaltestgegevens en uitleg over snelheid, kosten en limieten bij elkaar. Je leest hoe je HiPay in de betaalroute herkent en waarom de onderliggende kaart- of bankmethode bepaalt hoe je stort en uitbetaalt.",
    full_description:
      "HiPay verwerkt betalingen namens de aanbieder en kan verschillende onderliggende methoden aanbieden, zoals kaarten of bankbetalingen. Voor de speler bepaalt de onderliggende methode de snelheid, kosten en of uitbetalen mogelijk is.",
    logo_url: null,
    deposit_supported: true,
    withdrawal_supported: false,
    typical_deposit_speed: "Direct tot enkele minuten",
    typical_withdrawal_speed: "Afhankelijk van de onderliggende methode",
    min_deposit_general: 10,
    max_deposit_general: 5000,
    typical_fees: "Afhankelijk van de onderliggende methode",
    mobile_support: true,
    verification_notes: "De naam op de betaalpagina kan afwijken van de naam van de aanbieder.",
    available_in_netherlands: true,
    publication_status: "published",
    seo_title: "HiPay Casino 2026: Wat Je Moet Weten Vóór Je Stort",
    meta_description:
      "Vind de beste casino's met HiPay in november 2026. Bekijk welke aanbieders de verwerker gebruiken en wat wij maten voor snelheid en kosten. 18+.",
    pros: [
      "Bundelt meerdere betaalmethoden",
      "Snelle verwerking van stortingen",
      "Bekende Europese betaalverwerker",
    ],
    cons: [
      "Geen zelfstandige wallet voor spelers",
      "Voorwaarden hangen af van de onderliggende methode",
      "Minder herkenbaar op je afschrift",
    ],
    faq_items: [
      {
        q: "Is HiPay een wallet?",
        a: "Nee, het is een betaalverwerker. Je maakt geen HiPay-account aan als speler.",
      },
      {
        q: "Kan ik via HiPay laten uitbetalen?",
        a: "Dat hangt af van de onderliggende methode die de aanbieder gebruikt.",
      },
    ],
    sort_order: 6,
    last_verified_at: "2026-11-03T00:00:00Z",
  },
  {
    id: "pm-trustly",
    name: "Trustly",
    slug: "trustly",
    category: "bank",
    short_description: "Bankbetaling zonder wallet, ook geschikt voor uitbetalingen.",
    intro:
      "Wat zijn de beste online casino's met Trustly voor storten en uitbetalen? Hieronder vind je onze casinoselectie en betaaltestgegevens, met aandacht voor bankbetalingen, opnamesnelheid, kosten en limieten. We leggen ook uit hoe de rekeningcontrole werkt en wat je vóór je eerste opname controleert.",
    full_description:
      "Bij Trustly log je in via je eigen bank en autoriseer je de betaling. Anders dan bij iDEAL kan Trustly ook uitbetalingen terugzetten op dezelfde rekening, wat opnames vaak sneller maakt dan een gewone overschrijving.",
    logo_url: null,
    deposit_supported: true,
    withdrawal_supported: true,
    typical_deposit_speed: "Direct",
    typical_withdrawal_speed: "Vaak binnen 24 uur",
    min_deposit_general: 10,
    max_deposit_general: 10000,
    typical_fees: "Meestal geen kosten voor de speler",
    mobile_support: true,
    verification_notes: "Naam- en rekeningcontrole worden automatisch uitgevoerd.",
    available_in_netherlands: true,
    publication_status: "published",
    seo_title: "Trustly Casino 2026: Storten én Binnen Uren Uitbetaald Krijgen",
    meta_description:
      "Vind de beste Trustly casino's van november 2026. Getest op directe stortingen, snelle bankuitbetalingen, limieten en kosten. 18+.",
    pros: [
      "Storten en opnemen met dezelfde methode",
      "Geen extra wallet nodig",
      "Uitbetaling vaak sneller dan een gewone overschrijving",
    ],
    cons: [
      "Niet elke bank wordt ondersteund",
      "Minder bekend dan iDEAL",
      "Opnamesnelheid verschilt per aanbieder",
    ],
    faq_items: [
      {
        q: "Is Trustly veiliger dan een overschrijving?",
        a: "Trustly gebruikt de beveiligde inlogomgeving van je eigen bank en deelt geen inloggegevens met de aanbieder.",
      },
      {
        q: "Hoe snel is een uitbetaling via Trustly?",
        a: "Vaak binnen 24 uur, maar de aanbieder moet de opname eerst goedkeuren.",
      },
    ],
    sort_order: 7,
    last_verified_at: "2026-11-04T00:00:00Z",
  },
  {
    id: "pm-paysafecard",
    name: "Paysafecard",
    slug: "paysafecard",
    category: "prepaid",
    short_description: "Prepaid tegoedbon met een 16-cijferige code.",
    intro:
      "Hier vergelijk je onze selectie van de beste online casino's voor paysafecard, met betaaltestgegevens over prepaid stortingen, kosten en voucherlimieten. Je leest stap voor stap hoe je een code gebruikt, wat er met een restsaldo gebeurt en welke andere betaalroute nodig is om winst op te nemen.",
    full_description:
      "Je koopt een paysafecard bij een verkooppunt of online en voert de 16-cijferige code in bij de kassa. Omdat er geen rekening aan gekoppeld is, kan er ook geen geld naar terug: uitbetalen gebeurt via een andere methode. De methode is populair bij spelers die een strikt stortbudget willen aanhouden.",
    logo_url: null,
    deposit_supported: true,
    withdrawal_supported: false,
    typical_deposit_speed: "Direct",
    typical_withdrawal_speed: "Uitbetaling via een andere methode",
    min_deposit_general: 10,
    max_deposit_general: 1000,
    typical_fees: "Mogelijk beheerkosten op een ongebruikt saldo",
    mobile_support: true,
    verification_notes: "Bij uitbetaling moet je alsnog een rekening op eigen naam opgeven.",
    available_in_netherlands: true,
    publication_status: "published",
    seo_title: "Paysafecard Casino 2026: Spelen met Prepaid Code, Vast Budget",
    meta_description:
      "Vind de beste Paysafecard casino's van november 2026. Getest op voucherlimieten, kosten, snelheid en hoe je winst laat uitbetalen. 18+.",
    pros: [
      "Geen bankgegevens nodig bij het storten",
      "Helpt bij het bewaken van een stortbudget",
      "Direct bijgeschreven",
    ],
    cons: [
      "Uitbetalen is niet mogelijk",
      "Maximale waarde per code",
      "Mogelijke beheerkosten op restsaldo",
    ],
    faq_items: [
      {
        q: "Kan ik winst uit laten betalen op mijn paysafecard?",
        a: "Nee. Je geeft bij de uitbetaling een andere methode op, meestal een bankrekening op je eigen naam.",
      },
      {
        q: "Waar koop ik een paysafecard?",
        a: "Bij veel supermarkten, tankstations en kiosken, en online bij erkende verkooppunten.",
      },
    ],
    sort_order: 8,
    last_verified_at: "2026-11-04T00:00:00Z",
  },
  {
    id: "pm-paypal",
    name: "PayPal",
    slug: "paypal",
    category: "wallet",
    short_description: "Bekende wallet met koperbescherming en tweerichtingsverkeer.",
    intro:
      "Op zoek naar de beste online casino's met PayPal? Hieronder bekijk je onze casinoselectie, betaaltestgegevens en uitleg over storten, walletuitbetalingen, kosten en limieten. Je leest ook waarom beschikbaarheid per aanbieder verschilt en welke account- en bonusvoorwaarden je vooraf moet controleren.",
    full_description:
      "Met PayPal betaal je zonder je bankgegevens te delen met de aanbieder. Omdat het saldo op je PayPal-account kan worden teruggestort, is uitbetalen vaak mogelijk. PayPal stelt strenge eisen aan kansspelaanbieders, waardoor niet elke aanbieder de methode mag voeren.",
    logo_url: null,
    deposit_supported: true,
    withdrawal_supported: true,
    typical_deposit_speed: "Direct",
    typical_withdrawal_speed: "Vaak binnen 24 uur",
    min_deposit_general: 10,
    max_deposit_general: 10000,
    typical_fees: "Meestal geen kosten voor de speler bij euro-betalingen",
    mobile_support: true,
    verification_notes: "PayPal-account moet op dezelfde naam staan als het spelersaccount.",
    available_in_netherlands: true,
    publication_status: "published",
    seo_title: "PayPal Casino 2026: Waar Kun Je in Nederland met PayPal Spelen?",
    meta_description:
      "Vind de beste PayPal casino's van november 2026. Bekijk onze tests van stortingen, walletuitbetalingen, limieten en kosten. 18+.",
    pros: [
      "Storten en opnemen met één account",
      "Geen bankgegevens delen met de aanbieder",
      "Snelle verwerking",
    ],
    cons: [
      "Niet elke aanbieder mag PayPal voeren",
      "Soms uitgesloten van bonusaanbiedingen",
      "Valutakosten bij niet-euro transacties",
    ],
    faq_items: [
      {
        q: "Waarom biedt niet elk casino PayPal aan?",
        a: "PayPal stelt aanvullende eisen aan kansspelaanbieders en werkt alleen met partijen die daaraan voldoen.",
      },
      {
        q: "Kan ik met PayPal opnemen?",
        a: "Bij veel aanbieders wel. Controleer per aanbieder de kolom opnemen in de vergelijkingstabel.",
      },
    ],
    sort_order: 9,
    last_verified_at: "2026-11-03T00:00:00Z",
  },
  {
    id: "pm-skrill",
    name: "Skrill",
    slug: "skrill",
    category: "wallet",
    short_description: "E-wallet gericht op snelle internationale betalingen.",
    intro:
      "Welke online casino's zijn het beste voor betalingen met Skrill? Onze casinoselectie hieronder wordt gevolgd door betaaltestgegevens over stortingen en walletopnames, plus uitleg over limieten en totale kosten. Je ontdekt waar verificatie tijd kan kosten en wat doorboeken van je Skrill-saldo naar de bank betekent.",
    full_description:
      "Skrill bewaart je saldo in een eigen wallet die je oplaadt via bank of kaart. Bij aanbieders die Skrill ook als opnamemethode voeren, staat een goedgekeurde uitbetaling meestal snel in je wallet. Houd rekening met eigen tarieven van Skrill voor opnemen en valutawissel.",
    logo_url: null,
    deposit_supported: true,
    withdrawal_supported: true,
    typical_deposit_speed: "Direct",
    typical_withdrawal_speed: "Vaak binnen 24 uur",
    min_deposit_general: 10,
    max_deposit_general: 10000,
    typical_fees: "Wallet kan kosten rekenen bij opname of valutawissel",
    mobile_support: true,
    verification_notes: "Wallet moet geverifieerd zijn en op dezelfde naam staan.",
    available_in_netherlands: true,
    publication_status: "published",
    seo_title: "Skrill Casino 2026: Storten en Opnemen via Één Wallet",
    meta_description:
      "Vind de beste Skrill casino's van november 2026. Getest op stortingssnelheid, opname naar je wallet, limieten en totale kosten. 18+.",
    pros: [
      "Snel storten en opnemen",
      "Eén wallet voor meerdere aanbieders",
      "Duidelijk transactieoverzicht",
    ],
    cons: ["Eigen kosten van Skrill", "Soms uitgesloten van bonussen", "Extra verificatie bij de wallet"],
    faq_items: [
      {
        q: "Wat is het verschil tussen Skrill en Neteller?",
        a: "Beide zijn e-wallets van dezelfde groep. De verschillen zitten vooral in tarieven, limieten en welke aanbieders ze voeren.",
      },
      {
        q: "Rekent Skrill kosten?",
        a: "Skrill kan kosten rekenen voor opnemen en valutawissel. De aanbieder rekent doorgaans niets.",
      },
    ],
    sort_order: 10,
    last_verified_at: "2026-11-04T00:00:00Z",
  },
  {
    id: "pm-revolut",
    name: "Revolut",
    slug: "revolut",
    category: "bank",
    short_description: "Digitale bank met eigen IBAN en kaart, populair bij jongere spelers.",
    intro:
      "Hier vind je onze selectie van de beste online casino's voor betalingen met Revolut, met betaaltestgegevens en uitleg over stortingen, uitbetalingen, kosten en limieten. We bekijken de routes via je Revolut-kaart, IBAN en gekoppelde wallet, zodat je weet welke optie je in de kassa moet controleren en waar je winst terechtkomt.",
    full_description:
      "Revolut staat zelden als apart logo in de kassa, omdat het geen betaalmethode is maar een bankrekening met kaart. In de praktijk kies je in de kassa voor kaart, mobiele wallet of bankoverschrijving en zit Revolut daarachter. Stortingen komen doorgaans binnen enkele seconden aan; uitbetalingen lopen terug naar dezelfde kaart of naar je IBAN. Let op de kansspelblokkade in de app: die staat bij veel accounts standaard aan en weigert kaartbetalingen aan casino's.",
    logo_url: null,
    deposit_supported: true,
    withdrawal_supported: true,
    typical_deposit_speed: "Direct",
    typical_withdrawal_speed: "Enkele uren naar IBAN, 1-3 werkdagen naar kaart",
    min_deposit_general: 10,
    max_deposit_general: 10000,
    typical_fees: "Meestal geen kosten in euro's; opslag bij valutawissel boven de gratis limiet",
    mobile_support: true,
    verification_notes:
      "Rekening en kaart moeten op naam van de speler staan; kansspelblokkade in de app moet uit staan.",
    available_in_netherlands: true,
    publication_status: "published",
    seo_title: "Beste Revolut Casino's 2026: Top Online Casino met Revolut",
    meta_description:
      "Beste Revolut casino's van november 2026: zo werkt een online casino Revolut storting via kaart, IBAN of wallet, plus uitbetaling en kosten. 18+.",
    pros: [
      "Storting vrijwel altijd binnen seconden",
      "Meestal geen kosten in euro's",
      "Directe meldingen en uitgavenlimieten in de app",
      "Uitbetaling naar IBAN vaak sneller dan naar kaart",
    ],
    cons: [
      "Zelden als apart logo in de kassa te vinden",
      "Kansspelblokkade in de app blokkeert betalingen",
      "Wegwerpkaarten worden vaak geweigerd",
    ],
    faq_items: [
      {
        q: "Waarom wordt mijn Revolut-kaart geweigerd?",
        a: "Meestal door de kansspelblokkade in de Revolut-app. Zet die instelling uit en houd rekening met een wachttijd voordat de wijziging actief is.",
      },
      {
        q: "Welke casino's accepteren Revolut?",
        a: "Casino's die Revolut accepteren doen dat via de Revolut-kaart, Apple Pay, Google Pay of een overschrijving vanaf je IBAN. Een aparte Revolut-knop zie je zelden.",
      },
      {
        q: "Bestaat er een speciale Revolut casino bonus?",
        a: "Nee. Je krijgt de gewone welkomstbonus van het casino, zolang kaartbetalingen niet zijn uitgesloten in de bonusvoorwaarden.",
      },
      {
        q: "Kun je met Revolut laten uitbetalen?",
        a: "Ja. Het gestorte bedrag gaat vaak terug naar de kaart en de winst als overschrijving naar je Revolut-IBAN.",
      },
      {
        q: "Rekent Revolut kosten voor een casinostorting?",
        a: "Voor betalingen in euro's normaal gesproken niet. Bij een andere valuta geldt een opslag zodra je gratis wisselvolume op is.",
      },
    ],
    sort_order: 11,
    last_verified_at: "2026-11-04T00:00:00Z",
  },
  {
    id: "pm-visa",
    name: "Visa",
    slug: "visa",
    category: "kaart",
    short_description: "Het bekendste kaartnetwerk: betalen met je bankpas of creditcard.",
    intro:
      "Wat zijn de beste online casino's om met Visa te betalen? Hieronder vergelijk je onze casinoselectie, gevolgd door betaaltestgegevens over kaartstortingen, opnameverwerking, kosten en limieten. Je leest ook het verschil tussen Visa Debit en een creditcard en welke voorwaarden jouw kaartuitgever kan stellen.",
    full_description:
      "Visa is geen bank maar een kaartnetwerk: je betaalt altijd met een kaart die je eigen bank heeft uitgegeven en die op het Visa-netwerk draait. In de kassa vul je kaartnummer, vervaldatum en beveiligingscode in en bevestig je de betaling in je bankapp. Stortingen komen doorgaans binnen vijf tot tien seconden aan. Uitbetalen kan bij een deel van de aanbieders als terugboeking naar dezelfde kaart, tot maximaal het gestorte bedrag; je winst gaat als overschrijving naar je bankrekening. Weigeringen komen bijna altijd door de kansspelcategorie of de daglimiet in je eigen bankapp, niet door de kaart zelf.",
    logo_url: null,
    deposit_supported: true,
    withdrawal_supported: true,
    typical_deposit_speed: "Direct, 5-10 seconden",
    typical_withdrawal_speed: "1-4 werkdagen naar de kaart, winst per bankoverschrijving",
    min_deposit_general: 10,
    max_deposit_general: 10000,
    typical_fees: "Meestal geen kosten voor de speler; wisselkoersopslag bij vreemde valuta",
    mobile_support: true,
    verification_notes:
      "Kaart moet op naam van de speler staan; bij de eerste uitbetaling volgt doorgaans extra identificatie.",
    available_in_netherlands: true,
    publication_status: "published",
    seo_title: "Visa Casino 2026: Storten met Je Visa Debit of Creditcard",
    meta_description:
      "Vind de beste Visa casino's van november 2026. Tien aanbieders getest op stortingssnelheid, kaartuitbetaling, limieten en kosten. 18+.",
    pros: [
      "Vrijwel altijd beschikbaar in de kassa",
      "Storting binnen enkele seconden bijgeschreven",
      "Geen extra account of app nodig",
      "Bevestiging met 3D Secure in je eigen bankapp",
    ],
    cons: [
      "Uitbetaling naar de kaart duurt 1 tot 4 werkdagen",
      "Banken blokkeren kansspeltransacties soms standaard",
      "Creditcards kunnen kansspelbetalingen als contantopname belasten",
    ],
    faq_items: [
      {
        q: "Waarom wordt mijn Visa-kaart geweigerd bij een casino?",
        a: "Meestal staat de categorie kansspelen in je bankapp uit of is je daglimiet voor internetbetalingen te laag. Beide pas je zelf aan in de app van je bank.",
      },
      {
        q: "Kun je met Visa laten uitbetalen?",
        a: "Vaak wel: tot het gestorte bedrag boekt de aanbieder terug naar dezelfde kaart. Je winst komt als bankoverschrijving binnen, meestal binnen enkele uren tot een werkdag.",
      },
      {
        q: "Kost storten met Visa geld?",
        a: "Bij Nederlandse aanbieders rekenden we in onze tests geen kosten. Betaal je in een andere valuta, dan geldt een wisselkoersopslag van je kaartuitgever.",
      },
      {
        q: "Is Visa Debit hetzelfde als een creditcard?",
        a: "Nee. Visa Debit schrijft direct van je betaalrekening af; een creditcard rekent pas volgende maand af. Voor je speelbudget is een debetkaart de veiliger keuze.",
      },
    ],
    sort_order: 12,
    last_verified_at: "2026-11-04T00:00:00Z",
  },
  {
    id: "pm-mastercard",
    name: "Mastercard",
    slug: "mastercard",
    category: "kaart",
    short_description: "Wereldwijd kaartnetwerk: storten met je bankpas of creditcard.",
    intro:
      "Op deze pagina vind je onze selectie van de beste online casino's voor Mastercard, met betaaltestgegevens over storten, kaartuitbetalingen, kosten en limieten. We leggen uit hoe je betaling wordt bevestigd, wat het verschil is tussen een betaalpas en creditcard en wanneer je winst via je bankrekening terugkomt.",
    full_description:
      "Mastercard is geen bank maar een kaartnetwerk: je betaalt met een kaart die je eigen bank uitgaf en die op dat netwerk draait. In de kassa vul je kaartnummer, vervaldatum en beveiligingscode in en bevestig je met sterke authenticatie in je bankapp. Stortingen kwamen in onze tests binnen zes tot elf seconden aan. Uitbetalen kan bij een deel van de aanbieders als terugboeking naar dezelfde kaart, tot maximaal het gestorte bedrag; het meerdere komt als overschrijving op je bankrekening. Weigeringen komen bijna altijd door de kansspelcategorie of het daglimiet in je eigen bankapp.",
    logo_url: null,
    deposit_supported: true,
    withdrawal_supported: true,
    typical_deposit_speed: "Direct, 6-11 seconden",
    typical_withdrawal_speed: "20-45 uur naar de kaart, winst per bankoverschrijving",
    min_deposit_general: 10,
    max_deposit_general: 10000,
    typical_fees: "Meestal geen kosten voor de speler; wisselkoersopslag bij vreemde valuta",
    mobile_support: true,
    verification_notes:
      "Kaart moet op naam van de speler staan; bij de eerste uitbetaling volgt doorgaans extra identificatie.",
    available_in_netherlands: true,
    publication_status: "published",
    seo_title: "Mastercard Casino 2026: Wat Kun Je Wel en Niet met Je Kaart?",
    meta_description:
      "Vind de beste Mastercard casino's van november 2026. Tien aanbieders getest op snelheid, kaartuitbetaling, limieten en kosten. 18+.",
    pros: [
      "Werkt bij vrijwel elke aanbieder in onze vergelijking",
      "Storting binnen enkele seconden bijgeschreven",
      "Geen extra account of app nodig",
      "Bevestiging met sterke authenticatie in je bankapp",
    ],
    cons: [
      "Uitbetaling naar de kaart duurt 20 tot 45 uur",
      "Banken blokkeren kansspeltransacties soms standaard",
      "Creditcards kunnen een storting als contantopname belasten",
    ],
    faq_items: [
      {
        q: "Waarom wordt mijn Mastercard geweigerd bij een casino?",
        a: "Meestal staat de categorie kansspelen in je bankapp uit of is je daglimiet voor internetbetalingen te laag. Beide pas je zelf aan in de app van je bank.",
      },
      {
        q: "Kun je met Mastercard laten uitbetalen?",
        a: "Vaak wel: tot het gestorte bedrag boekt de aanbieder terug naar dezelfde kaart. Je winst komt als bankoverschrijving binnen, meestal een halve tot een hele werkdag sneller.",
      },
      {
        q: "Kost storten met Mastercard geld?",
        a: "Bij de geteste Nederlandse aanbieders rekenden we geen kosten. Speel je in een andere valuta, dan geldt een wisselkoersopslag van je kaartuitgever.",
      },
      {
        q: "Wat is het verschil met Visa?",
        a: "Praktisch weinig: het zijn twee kaartnetwerken met vergelijkbare regels en snelheden. Welk logo op je kaart staat, bepaalt je bank.",
      },
    ],
    sort_order: 13,
    last_verified_at: "2026-11-03T00:00:00Z",
  },
  {
    id: "pm-creditcard",
    name: "Creditcard",
    slug: "creditcard",
    category: "kaart",
    short_description: "Storten met je creditcard van Visa of Mastercard, met uitgestelde afschrijving.",
    intro:
      "Welke online casino's bieden kaartbetalingen met Visa of Mastercard? Hieronder vind je onze casinoselectie en betaaltestgegevens over creditcardstortingen, opnames, limieten en kosten. We besteden extra aandacht aan rente en uitgestelde afschrijving: betalen met krediet brengt schuldrisico mee en is geen manier om je speelbudget te vergroten.",
    full_description:
      "Bij een creditcard schiet je kaartuitgever het bedrag voor en int hij het later, meestal aan het eind van de maand. In de kassa ziet de betaling er hetzelfde uit als bij een debetkaart: kaartnummer, vervaldatum, beveiligingscode en een bevestiging in je bank- of kaartapp. Onze stortingen kwamen bij tien aanbieders binnen zes tot dertien seconden aan. Uitbetalen kan bij een deel van de aanbieders als terugboeking naar dezelfde kaart tot maximaal het gestorte bedrag; het meerdere komt als overschrijving op je bankrekening. Twee dingen maken een creditcard anders dan iedere andere betaalmethode op deze site: je speelt met geleend geld en sommige uitgevers behandelen een kansspelstorting als contantopname, waarover direct rente kan gaan lopen.",
    logo_url: null,
    deposit_supported: true,
    withdrawal_supported: true,
    typical_deposit_speed: "Direct, 6-13 seconden",
    typical_withdrawal_speed: "24-52 uur naar de kaart, winst per bankoverschrijving",
    min_deposit_general: 10,
    max_deposit_general: 10000,
    typical_fees: "Geen kosten bij de aanbieder; wel mogelijk contantopnamerente of valutaopslag van je kaartuitgever",
    mobile_support: true,
    verification_notes:
      "De kaart moet op naam van de speler staan; bij de eerste uitbetaling volgt vrijwel altijd extra identificatie.",
    available_in_netherlands: true,
    publication_status: "published",
    seo_title: "Online Casino Creditcard 2026: Kaartstortingen Uitgelegd",
    meta_description:
      "Vind de beste creditcard casino's van november 2026. Tien aanbieders getest op snelheid, rente, kosten, limieten en uitbetaling. 18+.",
    pros: [
      "Storting binnen enkele seconden bijgeschreven",
      "Werkt bij vrijwel elke aanbieder in onze vergelijking",
      "Uitgestelde afschrijving en aankoopbescherming van de uitgever",
      "Ook bruikbaar zonder saldo op je betaalrekening",
    ],
    cons: [
      "Je speelt met geleend geld: risico op oplopende schuld",
      "Sommige uitgevers boeken een storting als contantopname met directe rente",
      "Uitbetaling naar de kaart duurt in onze test 24 tot 52 uur",
      "Kaartuitgevers blokkeren kansspeltransacties soms standaard",
    ],
    faq_items: [
      {
        q: "Kun je in een online casino met creditcard betalen?",
        a: "Ja. Alle tien aanbieders in onze vergelijking accepteren creditcards van Visa en Mastercard. Je vult je kaartgegevens in de kassa in en bevestigt de betaling in de app van je kaartuitgever.",
      },
      {
        q: "Rekent een creditcard kosten voor een casinostorting?",
        a: "De aanbieder rekende in onze tests niets. Je kaartuitgever kan een kansspelstorting wel als contantopname boeken; dan geldt een opnamefee en loopt de rente direct, zonder rentevrije periode.",
      },
      {
        q: "Kun je met een creditcard laten uitbetalen?",
        a: "Meestal wel tot het gestorte bedrag: dat gaat als terugboeking naar dezelfde kaart. Je winst daarboven komt als bankoverschrijving binnen, in onze test doorgaans sneller dan de kaartterugboeking.",
      },
      {
        q: "Waarom weigert mijn creditcard de betaling?",
        a: "Bijna altijd door je eigen uitgever: de categorie kansspelen staat uit, je bestedingslimiet is bereikt of de transactie wordt als risicovol gemarkeerd. Dat pas je aan in de app van je kaartuitgever.",
      },
      {
        q: "Is een creditcard verstandig om mee te spelen?",
        a: "Voor budgetbewaking niet. Je speelt met geleend geld en ziet pas op het maandoverzicht wat je hebt uitgegeven. Een debetkaart of iDEAL schrijft direct af en houdt je budget zichtbaar.",
      },
    ],
    sort_order: 14,
    last_verified_at: "2026-11-04T00:00:00Z",
  },
  {
    id: "pm-klarna",
    name: "Klarna",
    slug: "klarna",
    category: "bank",
    short_description: "Betalen via de Klarna-app, direct van je rekening in plaats van achteraf.",
    intro:
      "Hier vergelijk je onze selectie van de beste online casino's voor directe betalingen via Klarna, met betaaltestgegevens, stortlimieten en kosten. Je leest hoe de betaalroute werkt en via welke methode je winst opneemt. We maken daarbij onderscheid tussen direct betalen en achteraf betalen; krediet is geen alternatief voor je speelbudget.",
    full_description:
      "Klarna is een Zweedse bank die betalingen initieert en afwikkelt. Bij een casinostorting kies je Klarna in de kassa, log je in de Klarna-app in en bevestig je de betaling met pincode of biometrie. Achteraf betalen, waar Klarna het bekendst om is, wordt bij kansspelaanbieders vrijwel nooit aangeboden: in onze testronde stond bij alle negen aanbieders alleen directe betaling open. Uitbetalen via Klarna kan niet; je winst komt als bankoverschrijving of via een andere methode binnen. Onze stortingen kwamen in elf tot achttien seconden aan, iets trager dan een directe bankbetaling omdat de Klarna-app een extra bevestigingsstap toevoegt.",
    logo_url: null,
    deposit_supported: true,
    withdrawal_supported: false,
    typical_deposit_speed: "Direct, 11-18 seconden",
    typical_withdrawal_speed: "Uitbetaling via bankoverschrijving",
    min_deposit_general: 10,
    max_deposit_general: 5000,
    typical_fees: "Geen kosten voor de speler bij directe betaling",
    mobile_support: true,
    verification_notes: "Je Klarna-account moet op dezelfde naam staan als je spelersaccount; achteraf betalen is bij kansspelen niet beschikbaar.",
    available_in_netherlands: true,
    publication_status: "published",
    seo_title: "Beste Klarna casino's 2026: storten, kosten en limieten",
    meta_description:
      "Vind de beste Klarna casino's van november 2026. Negen aanbieders getest op directe betaling, snelheid, limieten en kosten. 18+.",
    pros: [
      "Bevestigen in de vertrouwde Klarna-app",
      "Geen kaartgegevens in de casinokassa",
      "Direct bijgeschreven speeltegoed",
      "Overzicht van al je betalingen op één plek",
    ],
    cons: [
      "Uitbetalen met Klarna zelf is niet mogelijk",
      "Achteraf betalen wordt bij kansspelen niet aangeboden",
      "Iets trager dan een directe bankbetaling",
      "Niet elke aanbieder heeft Klarna in de kassa",
    ],
    faq_items: [
      {
        q: "Kun je in een casino achteraf betalen met Klarna?",
        a: "Nee. Bij kansspelaanbieders staat alleen directe betaling open; het bedrag gaat meteen van je rekening. Dat is bewust beleid van Klarna en de aanbieders zelf.",
      },
      {
        q: "Kun je met Klarna laten uitbetalen?",
        a: "Nee. Je winst komt als bankoverschrijving binnen op de rekening die aan je spelersaccount is gekoppeld.",
      },
      {
        q: "Wat kost storten met Klarna?",
        a: "Bij directe betaling rekenen de aanbieders in onze test niets. Kosten ontstaan alleen als je een factuur van Klarna te laat betaalt, en dat speelt bij kansspelen niet.",
      },
      {
        q: "Hoe snel staat een Klarna-storting op je account?",
        a: "In onze tests tussen elf en achttien seconden, met een mediaan van veertien seconden bij negen aanbieders.",
      },
    ],
    sort_order: 15,
    last_verified_at: "2026-11-04T00:00:00Z",
  },
  {
    id: "pm-afterpay",
    name: "AfterPay",
    slug: "afterpay-casinos",
    category: "bank",
    short_description: "Riverty (voorheen AfterPay): achteraf betalen, niet beschikbaar in Nederlandse casinokassa's.",
    intro:
      "Zoek je een online casino met AfterPay of Riverty? Deze pagina legt uit waarom die achterafbetaaldienst geen casinostortmethode is en vergelijkt onze casinoselectie op directe alternatieven. Hieronder vind je uitleg over betaaltestgegevens, kosten, limieten en uitbetalen, zonder achteraf betalen als beschikbare casino-optie voor te stellen.",
    full_description:
      "Riverty is sinds 2023 de nieuwe naam van AfterPay in Nederland. Je betaalt een aankoop achteraf, meestal binnen veertien dagen, na een korte kredietbeoordeling. Kansspelaanbieders met een Nederlandse vergunning mogen spelers niet laten spelen met geleend geld, en Riverty sluit kansspelen uit. In de kassa's van alle aanbieders in onze vergelijking staat Riverty daarom niet. Alternatieven met vergelijkbaar gemak zijn iDEAL, Klarna (alleen directe betaling) en Trustly.",
    logo_url: null,
    deposit_supported: false,
    withdrawal_supported: false,
    typical_deposit_speed: "Niet beschikbaar in casino's",
    typical_withdrawal_speed: "Niet beschikbaar; uitbetaling via bankoverschrijving",
    min_deposit_general: null,
    max_deposit_general: null,
    typical_fees: "Niet van toepassing; bij webwinkels aanmaningskosten bij te laat betalen",
    mobile_support: true,
    verification_notes: "Achteraf betalen is een vorm van krediet en is bij Nederlandse kansspelaanbieders niet toegestaan.",
    available_in_netherlands: true,
    publication_status: "published",
    seo_title: "AfterPay Casino 2026: Kan je Achteraf Betalen met Riverty?",
    meta_description:
      "AfterPay casino's en Riverty casino's in november 2026: kan je achteraf betalen in een online casino? Kassacheck, risico's en de beste directe alternatieven. 18+.",
    pros: [
      "Duidelijkheid: geen risico op schuld na het spelen",
      "Directe alternatieven zoals iDEAL zijn net zo eenvoudig",
      "Klarna biedt hetzelfde app-gevoel met directe betaling",
      "Prepaid vouchers houden je budget strak",
    ],
    cons: [
      "Riverty staat in geen enkele Nederlandse casinokassa",
      "Achteraf betalen bij kansspelen is niet toegestaan",
      "Uitbetalen via Riverty kan niet",
      "Sites die AfterPay beloven zijn vaak onbetrouwbaar",
    ],
    faq_items: [
      { q: "Kan je in een online casino betalen met AfterPay?", a: "Nee. AfterPay heet nu Riverty en is achteraf betalen. Aanbieders met een Nederlandse vergunning bieden geen krediet aan, en Riverty sluit kansspelen uit." },
      { q: "Is Riverty hetzelfde als AfterPay?", a: "Ja. In Nederland is AfterPay in 2023 hernoemd naar Riverty. Het Australische Afterpay is een ander bedrijf." },
      { q: "Wat is het beste alternatief voor AfterPay in een casino?", a: "iDEAL voor de meeste spelers. Wie een betaalapp wil, kiest Klarna, waar in de casinokassa alleen directe betaling openstaat." },
      { q: "Kan ik met Riverty een tegoedbon kopen om te storten?", a: "Dat raden we sterk af. Je speelt dan met geleend geld via een omweg, met alle risico's van een openstaande factuur." },
      { q: "Kan ik winst laten uitbetalen via Riverty?", a: "Nee. Riverty kan geen geld naar je sturen. Winst komt via een bankoverschrijving op de rekening op jouw naam." },
    ],
    sort_order: 30,
    last_verified_at: "2026-11-03T00:00:00Z",
  },
  {
    id: "pm-muchbetter",
    name: "MuchBetter",
    slug: "muchbetter",
    category: "wallet",
    short_description: "Wallet-app die speciaal voor kansspelbetalingen is gebouwd, met storten én opnemen.",
    intro:
      "Wat zijn de beste online casino's voor MuchBetter? Hieronder vind je onze casinoselectie, betaaltestgegevens en uitleg over mobiele stortingen en opnames naar je wallet. Je leest welke verificatie nodig kan zijn, welke limieten gelden en wat opladen of doorboeken naar je bank kost.",
    full_description:
      "MuchBetter is een wallet-app die je koppelt aan een bankrekening of kaart. Je vult je saldo op, kiest MuchBetter in de casinokassa en bevestigt de betaling met je vingerafdruk of gezichtsherkenning. Omdat de wallet in beide richtingen werkt, kun je een uitbetaling rechtstreeks naar je walletsaldo laten komen: in onze test stond dat mediaan binnen drie uur. Daarna maak je het bedrag zelf over naar je bankrekening. De methode is populair bij spelers die betaalgegevens uit de kassa willen houden en die snelheid belangrijker vinden dan de laagste kosten.",
    logo_url: null,
    deposit_supported: true,
    withdrawal_supported: true,
    typical_deposit_speed: "Direct, 4-8 seconden",
    typical_withdrawal_speed: "Mediaan 3 uur naar je walletsaldo",
    min_deposit_general: 10,
    max_deposit_general: 5000,
    typical_fees: "Storten gratis; opladen en doorboeken naar de bank kan kosten met zich meebrengen",
    mobile_support: true,
    verification_notes: "De wallet moet op naam van de speler staan en volledig geverifieerd zijn voordat een uitbetaling wordt vrijgegeven.",
    available_in_netherlands: true,
    publication_status: "published",
    seo_title: "MuchBetter Casino 2026: Mobiele Wallet Getest op Snelheid",
    meta_description:
      "Vind de beste MuchBetter casino's van november 2026. Tien aanbieders getest op storten, snelle walletuitbetaling, verificatie en kosten. 18+.",
    pros: [
      "Storten én opnemen via dezelfde wallet",
      "Snelste mobiele bevestiging in onze testronde",
      "Geen bank- of kaartgegevens in de casinokassa",
      "Uitbetaling mediaan binnen drie uur op het saldo",
    ],
    cons: [
      "Je hebt een extra app en account nodig",
      "Opladen met kaart kan kosten met zich meebrengen",
      "Geld doorboeken naar je bank is een extra stap",
      "Minder bekend dan de grote wallets",
    ],
    faq_items: [
      {
        q: "Kun je met MuchBetter ook laten uitbetalen?",
        a: "Ja. Bij de aanbieders in onze vergelijking komt de uitbetaling terug op je walletsaldo, in onze test mediaan binnen drie uur. Daarna boek je het bedrag zelf door naar je bank.",
      },
      {
        q: "Wat kost MuchBetter?",
        a: "Storten bij de aanbieder is gratis. MuchBetter zelf kan kosten rekenen voor opladen met een kaart en voor het doorboeken van je saldo naar je bankrekening.",
      },
      {
        q: "Is MuchBetter veilig?",
        a: "De wallet valt onder toezicht als elektronischgeldinstelling en elke betaling bevestig je met biometrie in de app. Je bankgegevens komen nooit in de casinokassa terecht.",
      },
      {
        q: "Hoe snel is een storting met MuchBetter?",
        a: "In onze tests vier tot acht seconden, met een mediaan van vijf seconden bij tien aanbieders.",
      },
    ],
    sort_order: 16,
    last_verified_at: "2026-11-04T00:00:00Z",
  },
  {
    id: "pm-neosurf",
    name: "Neosurf",
    slug: "neosurf",
    category: "prepaid",
    short_description: "Prepaid voucher met een code: je stort nooit meer dan je vooraf koopt.",
    intro:
      "Op zoek naar de beste online casino's voor Neosurf? Hieronder vergelijk je onze casinoselectie, met betaaltestgegevens over voucherstortingen, snelheid, kosten en limieten. We leggen uit hoe je een code gebruikt en waarom je voor het opnemen van winst een andere betaalroute en rekeningverificatie nodig hebt.",
    full_description:
      "Neosurf werkt als een cadeaubon voor betalingen. Je koopt een voucher met een code van tien tot honderd euro, vult die code in de kassa in en het bedrag staat direct als speeltegoed klaar. Er komt geen bankrekening, kaart of account aan te pas, waardoor het de methode is met de strakste budgetbewaking in onze vergelijking: op is op. Uitbetalen met een voucher kan niet, want een code werkt maar één kant op. Je winst komt daarom als bankoverschrijving binnen, waarvoor je bij de eerste opname altijd je identiteit en rekening moet bevestigen.",
    logo_url: null,
    deposit_supported: true,
    withdrawal_supported: false,
    typical_deposit_speed: "Direct, 7-12 seconden",
    typical_withdrawal_speed: "Uitbetaling via bankoverschrijving",
    min_deposit_general: 10,
    max_deposit_general: 500,
    typical_fees: "Geen kosten bij de aanbieder; het verkooppunt kan een opslag rekenen",
    mobile_support: true,
    verification_notes: "De voucher is anoniem, maar je spelersaccount niet: bij de eerste uitbetaling volgt altijd identificatie.",
    available_in_netherlands: true,
    publication_status: "published",
    seo_title: "Neosurf Casino 2026: Anoniem Storten met een Voucher",
    meta_description:
      "Vind de beste Neosurf casino's van november 2026. Tien aanbieders getest op vouchers, stortingssnelheid, limieten en kosten. 18+.",
    pros: [
      "Harde budgetgrens: je stort nooit meer dan de voucher",
      "Geen bank- of kaartgegevens nodig",
      "Direct bijgeschreven na het invullen van de code",
      "Verkrijgbaar bij fysieke verkooppunten",
    ],
    cons: [
      "Uitbetalen met Neosurf zelf kan niet",
      "Maximaal enkele honderden euro's per voucher",
      "Een verloren code is verloren tegoed",
      "Verkooppunten kunnen een opslag rekenen",
    ],
    faq_items: [
      {
        q: "Kun je met Neosurf laten uitbetalen?",
        a: "Nee. Een voucher werkt één kant op. Je winst komt als bankoverschrijving binnen op een rekening op jouw naam.",
      },
      {
        q: "Waar koop je een Neosurf-voucher?",
        a: "Bij gemakswinkels, tankstations en online verkooppunten in Nederland. Let op de coupures: die lopen doorgaans van tien tot honderd euro.",
      },
      {
        q: "Is storten met Neosurf anoniem?",
        a: "De voucher zelf is anoniem, maar je spelersaccount is dat nooit. Bij je eerste uitbetaling controleert de aanbieder je identiteit en je rekening.",
      },
      {
        q: "Wat kost een Neosurf-storting?",
        a: "De aanbieders in onze test rekenden niets. Het verkooppunt waar je de voucher koopt, kan wel een kleine opslag hanteren.",
      },
    ],
    sort_order: 17,
    last_verified_at: "2026-11-04T00:00:00Z",
  },
  {
    id: "pm-telefoonrekening",
    name: "Pay by Phone",
    slug: "telefoonrekening",
    category: "mobiel",
    short_description: "Storten via je telefoonrekening of prepaid-saldo, bevestigd met een sms.",
    intro:
      "Welke online casino's zijn het beste voor betalen met telefoonrekening? Hieronder vind je onze casinoselectie, gevolgd door betaaltestgegevens, de dagcap van je provider, kosten en limieten. Je leest hoe je met een sms-bevestiging zonder bankgegevens stort, waarom opnemen via de telefoonrekening niet kan en via welke route je winst wordt uitbetaald.",
    full_description:
      "Betalen met telefoonrekening (Pay by Phone) is carrier billing: een betaaldienstverlener boekt het stortbedrag bij je mobiele provider, die het op je maandfactuur zet of van je prepaid-saldo aftrekt. Je identificeert je met je mobiele nummer en bevestigt de betaling met een sms. Er komt geen bankrekening of kaart aan te pas, en de provider hanteert een dagcap die grootte van je storting begrenst. Uitbetalen via de telefoonrekening kan niet; je winst komt als bankoverschrijving binnen op de rekening die aan je spelersaccount is gekoppeld. Onze stortingen boekten in 38 tot 68 seconden, met een mediaan van 50 seconden, trager dan een directe bankbetaling door de extra sms-bevestiging.",
    logo_url: null,
    deposit_supported: true,
    withdrawal_supported: false,
    typical_deposit_speed: "Direct, 38-68 seconden",
    typical_withdrawal_speed: "Niet via de telefoonrekening; uitbetaling via bankoverschrijving",
    min_deposit_general: 10,
    max_deposit_general: 150,
    typical_fees: "Geen bij de aanbieder; je provider kan een servicetarief rekenen",
    mobile_support: true,
    verification_notes: "Je telefoonnummer moet bij een abonnement op je eigen naam horen; het spelersaccount moet op dezelfde naam staan als de telefoonrekening.",
    available_in_netherlands: true,
    publication_status: "published",
    seo_title: "Online Casino Betalen met Telefoonrekening 2026",
    meta_description:
      "Vind de beste casino's voor betalen met telefoonrekening van november 2026. Tien aanbieders getest op snelheid, sms-bevestiging, dagcap en kosten. 18+.",
    pros: [
      "Storten zonder bankgegevens of kaartnummer",
      "Bevestiging met één sms, geen app of extra account",
      "Direct bijgeschreven speeltegoed",
      "Dagcap van de provider begrenst je budget automatisch",
    ],
    cons: [
      "Opnemen kan niet via de telefoonrekening",
      "Dagcap van de provider begrenst grote stortingen",
      "Niet elke provider of prepaid-abonnement ondersteunt carrier billing",
      "Trager dan een directe bankbetaling door de sms-bevestiging",
    ],
    faq_items: [
      {
        q: "Hoe werkt betalen met telefoonrekening in een online casino?",
        a: "Je kiest de optie in de kassa, vult je mobiele nummer in en bevestigt de storting met de sms-code van de betaaldienstverlener. Het bedrag wordt op je telefoonrekening geboekt of van je prepaid-saldo afgeschreven en staat direct als speeltegoed klaar.",
      },
      {
        q: "Kun je met de telefoonrekening laten uitbetalen?",
        a: "Nee. Een providerfactuur is geen rekening waarop geld kan binnenkomen. Je winst komt als bankoverschrijving binnen op de rekening die aan je spelersaccount is gekoppeld.",
      },
      {
        q: "Wat kost storten via de telefoonrekening?",
        a: "De aanbieders in onze test rekenden niets door. Je provider kan wel een servicetarief bovenop carrier-billingtransacties rekenen; controleer dat op je factuur of bij je provider.",
      },
      {
        q: "Kan het ook met prepaid?",
        a: "Ja, zolang je provider carrier billing op prepaid ondersteunt en er genoeg beltegoed staat. Het bedrag wordt dan direct van je saldo afgeschreven, wat een extra natuurlijke grens aan je storting geeft.",
      },
    ],
    sort_order: 18,
    last_verified_at: "2026-11-04T00:00:00Z",
  },
];



export const CHANGELOG: ChangelogEntry[] = [
  {
    id: "cl-telefoonrekening",
    page_type: "payment_method",
    page_slug: "telefoonrekening",
    change_summary: "Nieuwe pagina over betalen met telefoonrekening (Pay by Phone) gepubliceerd, inclusief stortings- en verificatietests bij tien aanbieders.",
    checked_by: "Wietse van Koppen",
    published_at: "2026-11-04T00:00:00Z",
  },
  {
    id: "cl-refresh-oct09",
    page_type: "site",
    page_slug: null,
    change_summary: "Oktobercontrole afgerond: alle live pagina's inhoudelijk aangescherpt, commerciële zoekresultaattitels vernieuwd en controledatums gesynchroniseerd.",
    checked_by: "Wietse van Koppen",
    published_at: "2026-10-09T00:00:00Z",
  },
  {
    id: "cl-payments-oct09",
    page_type: "payment_method",
    page_slug: null,
    change_summary: "Alle 17 betaalmethoden opnieuw gecontroleerd op kassa, kosten, limieten en uitbetaalroute; oktobercontext aan ieder artikel toegevoegd.",
    checked_by: "Robert Bemelmans",
    published_at: "2026-10-09T00:00:00Z",
  },
  {
    id: "cl-refresh-sep15",
    page_type: "site",
    page_slug: null,
    change_summary:
      "Volledige verfrisronde: alle betaalmethodepagina's en gidsen hermeten en voorzien van nieuwe EEAT-blokken over testopzet, bronnen, transparantie en correcties.",
    checked_by: "Wietse van Koppen",
    published_at: "2026-09-15T00:00:00Z",
  },
  {
    id: "cl-methodologie",
    page_type: "site",
    page_slug: null,
    change_summary: "Methodologiepagina gepubliceerd met de volledige weging per criterium en onze controlecyclus.",
    checked_by: "Wietse van Koppen",
    published_at: "2026-09-15T00:00:00Z",
  },
  {
    id: "cl-verantwoord-spelen",
    page_type: "site",
    page_slug: null,
    change_summary: "Gids verantwoord spelen gepubliceerd: limieten per betaalroute, signalen in je bankafschrift en hulpinstanties.",
    checked_by: "Jan-Jaap Bolkesteijn",
    published_at: "2026-09-15T00:00:00Z",
  },
  {
    id: "cl-20-euro",
    page_type: "site",
    page_slug: null,
    change_summary: "Nieuwe pagina over 20 euro storten gepubliceerd, met stortings- en opnametests bij tien aanbieders.",
    checked_by: "Wietse van Koppen",
    published_at: "2026-09-15T00:00:00Z",
  },
  {
    id: "cl-klarna",
    page_type: "payment_method",
    page_slug: "klarna",
    change_summary: "Nieuwe pagina over Klarna gepubliceerd, inclusief testronde bij negen aanbieders.",
    checked_by: "Wietse van Koppen",
    published_at: "2026-09-08T00:00:00Z",
  },
  {
    id: "cl-muchbetter",
    page_type: "payment_method",
    page_slug: "muchbetter",
    change_summary: "Nieuwe pagina over MuchBetter gepubliceerd, inclusief stort- en opnametests bij tien aanbieders.",
    checked_by: "Wietse van Koppen",
    published_at: "2026-09-08T00:00:00Z",
  },
  {
    id: "cl-neosurf",
    page_type: "payment_method",
    page_slug: "neosurf",
    change_summary: "Nieuwe pagina over Neosurf gepubliceerd, inclusief vouchertests bij tien aanbieders.",
    checked_by: "Wietse van Koppen",
    published_at: "2026-09-08T00:00:00Z",
  },
  {
    id: "cl-mastercard",
    page_type: "payment_method",
    page_slug: "mastercard",
    change_summary: "Nieuwe pagina over Mastercard gepubliceerd, inclusief testronde bij tien aanbieders.",
    checked_by: "Wietse van Koppen",
    published_at: "2026-09-05T00:00:00Z",
  },
  {
    id: "cl-visa",
    page_type: "payment_method",
    page_slug: "visa",
    change_summary: "Nieuwe pagina over Visa gepubliceerd, inclusief testronde bij tien aanbieders.",
    checked_by: "Wietse van Koppen",
    published_at: "2026-09-04T00:00:00Z",
  },
  {
    id: "cl-10",
    page_type: "site",
    page_slug: null,
    change_summary: "Drie nieuwe betaalnieuwsartikelen: strengere bankrekeningcontrole, opnemen zonder rondspeelverplichting en Wero bij Rabobank.",
    checked_by: "Naomi Bootman",
    published_at: "2026-10-16T09:00:00Z",
  },
  {
    id: "cl-11",
    page_type: "site",
    page_slug: null,
    change_summary: "Alle metatitels en omschrijvingen per pagina herschreven op basis van zoekwoordonderzoek; geen herhaald sjabloon meer.",
    checked_by: "Wietse van Koppen",
    published_at: "2026-10-16T08:00:00Z",
  },
  {
    id: "cl-1",
    page_type: "site",
    page_slug: null,
    change_summary: "Eerste versie van de betaalmethodendatabase met tien gepubliceerde methoden.",
    checked_by: "Redactie",
    published_at: "2026-08-30T00:00:00Z",
  },
  {
    id: "cl-2",
    page_type: "payment_method",
    page_slug: "ideal",
    change_summary: "Uitbetaalinformatie verduidelijkt: opnames lopen via bankoverschrijving.",
    checked_by: "Redactie",
    published_at: "2026-08-27T00:00:00Z",
  },
  {
    id: "cl-3",
    page_type: "payment_method",
    page_slug: "apple-pay",
    change_summary: "Toegevoegd dat alleen directe Apple Pay-integraties als ondersteuning tellen.",
    checked_by: "Redactie",
    published_at: "2026-08-24T00:00:00Z",
  },
  {
    id: "cl-4",
    page_type: "casino",
    page_slug: "wakuna",
    change_summary: "Wakuna toegevoegd met bonus, stortminimum, uitbetaaltijd en opnamelimiet.",
    checked_by: "Redactie",
    published_at: "2026-10-14T00:00:00Z",
  },
];
